import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { AuthenticationWrapper, RolePermissionEnum } from '../../service/dto';
import { AuthService } from '../../service/auth.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-access-control',
	standalone: false,
	templateUrl: './access-control.component.html',
	styleUrl: './access-control.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccessControlComponent implements OnChanges {
	@Input() authedState!: AuthenticationWrapper;
	@Input() permissions!: RolePermissionEnum[];
	hasAccess = false;


	ngOnChanges(changes: SimpleChanges): void {
		if (!this.authedState) {
			this.hasAccess = false;
			return;
		}
		if (!this.authedState.agent.appRole) {
			this.hasAccess = false;
			return;
		}

		for (let perm of this.permissions) {
			if (this.authedState.agent.appRole.permissions.filter(i=>i.selected == true).map(i=>i.permission).indexOf(perm) != -1) {
				this.hasAccess = true;
				return;
			}
		}
		this.hasAccess = false;
	}
}
